exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .highlight-first tag:first-of-type {\n  background: #FFF80D !important;\n}\n::ng-deep .ng2-dropdown-menu {\n  left: unset !important;\n  display: none;\n}\n.btn-primary {\n  margin-top: 1em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/journeys/journey/add-journey-users/add-journey-users.component.less
// module id = ../../../../../src/app/dashboard/journeys/journey/add-journey-users/add-journey-users.component.less
// module chunks = 2